import axios from 'axios';
import {supplier_arry} from "config"

export const SET_NOTE_ID = 'SET_NOTE_ID';

export const setNoteId = data =>({
    type:SET_NOTE_ID,
    payload:data
});